import { service } from '../../../../helpers/http' 

export const ActionGetAmbienceCategories = ({ dispatch }, payload) => { 
    return service({
        module: 'domainAmbienceCategory',
        action: 'getAmbienceCategories',
        payload: payload
    })
}

export const ActionPostAmbienceCategories = ({ dispatch }, payload) => {

    return service({
        module: 'domainAmbienceCategory',
        action: 'postAmbienceCategories',
        payload: payload
    })
    
}

export const ActionPutAmbienceCategories = ({ dispatch }, payload) => {

    return service({
        module: 'domainAmbienceCategory',
        action: 'putAmbienceCategories',
        payload: payload
    })
    
}

export const ActionDeleteAmbienceCategories = ({ dispatch }, payload) => {

    return service({
        module: 'domainAmbienceCategory',
        action: 'deleteAmbienceCategories',
        payload: payload
    })
    
}
